import { useEffect } from "react";

export function Modal({
  titulo,
  subtitulo,
  largura = 720,
  onFechar,
  children,
  rodape,
}: {
  titulo: string;
  subtitulo?: React.ReactNode;
  largura?: number;
  onFechar: () => void;
  children: React.ReactNode;
  rodape?: React.ReactNode;
}) {
  useEffect(() => {
    const aoTeclar = (e: KeyboardEvent) => e.key === "Escape" && onFechar();
    window.addEventListener("keydown", aoTeclar);
    return () => window.removeEventListener("keydown", aoTeclar);
  }, [onFechar]);

  return (
    <div
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", zIndex: 900, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
      onClick={(e) => e.target === e.currentTarget && onFechar()}
    >
      <div style={{ background: "#fff", borderRadius: 16, maxWidth: largura, width: "100%", maxHeight: "92vh", display: "flex", flexDirection: "column", boxShadow: "0 24px 80px rgba(0,0,0,.25)" }}>
        <div style={{ padding: "16px 24px", borderBottom: "1px solid #eaecf0", display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 16 }}>
          <div>
            <h2 style={{ margin: 0, fontSize: 17, color: "var(--verde)" }}>{titulo}</h2>
            {subtitulo && <div style={{ fontSize: 12, color: "var(--texto-suave)", marginTop: 4 }}>{subtitulo}</div>}
          </div>
          <button onClick={onFechar} style={{ background: "none", border: "none", fontSize: 22, cursor: "pointer", color: "#667", lineHeight: 1 }} aria-label="Fechar">✕</button>
        </div>
        <div style={{ padding: "20px 24px", overflow: "auto", flex: 1 }}>{children}</div>
        {rodape && (
          <div style={{ padding: "14px 24px", borderTop: "1px solid #eaecf0", display: "flex", gap: 10, justifyContent: "flex-end" }}>
            {rodape}
          </div>
        )}
      </div>
    </div>
  );
}

export function Confirmacao({
  titulo,
  mensagem,
  rotuloConfirmar = "Confirmar",
  perigo,
  onConfirmar,
  onCancelar,
}: {
  titulo: string;
  mensagem: React.ReactNode;
  rotuloConfirmar?: string;
  perigo?: boolean;
  onConfirmar: () => void;
  onCancelar: () => void;
}) {
  return (
    <Modal
      titulo={titulo}
      largura={440}
      onFechar={onCancelar}
      rodape={
        <>
          <button className="botao secundario" onClick={onCancelar}>Cancelar</button>
          <button
            className="botao"
            style={perigo ? { background: "#d92d20" } : undefined}
            onClick={onConfirmar}
          >
            {rotuloConfirmar}
          </button>
        </>
      }
    >
      <div style={{ fontSize: 14, lineHeight: 1.6 }}>{mensagem}</div>
    </Modal>
  );
}
